// Comprehensive world timezone database
// Organized by region with city names, labels, and UTC offsets

export const TIMEZONE_DATABASE = [
  // North America - USA
  { id: "America/New_York", label: "NYC", city: "New York", country: "USA", offset: -5 },
  { id: "America/Los_Angeles", label: "LAX", city: "Los Angeles", country: "USA", offset: -8 },
  { id: "America/Chicago", label: "CHI", city: "Chicago", country: "USA", offset: -6 },
  { id: "America/Denver", label: "DEN", city: "Denver", country: "USA", offset: -7 },
  { id: "America/Phoenix", label: "PHX", city: "Phoenix", country: "USA", offset: -7 },
  { id: "America/Dallas", label: "DFW", city: "Dallas", country: "USA", offset: -6 },
  { id: "America/Houston", label: "IAH", city: "Houston", country: "USA", offset: -6 },
  { id: "America/Miami", label: "MIA", city: "Miami", country: "USA", offset: -5 },
  { id: "America/Atlanta", label: "ATL", city: "Atlanta", country: "USA", offset: -5 },
  { id: "America/Seattle", label: "SEA", city: "Seattle", country: "USA", offset: -8 },
  { id: "America/San_Francisco", label: "SFO", city: "San Francisco", country: "USA", offset: -8 },
  { id: "America/Las_Vegas", label: "LAS", city: "Las Vegas", country: "USA", offset: -8 },
  { id: "America/Boston", label: "BOS", city: "Boston", country: "USA", offset: -5 },
  { id: "America/Detroit", label: "DTW", city: "Detroit", country: "USA", offset: -5 },
  { id: "America/Minneapolis", label: "MSP", city: "Minneapolis", country: "USA", offset: -6 },
  { id: "America/Anchorage", label: "ANC", city: "Anchorage", country: "USA", offset: -9 },
  { id: "Pacific/Honolulu", label: "HNL", city: "Honolulu", country: "USA", offset: -10 },

  // North America - Mexico
  { id: "America/Mexico_City", label: "MEX", city: "Mexico City", country: "Mexico", offset: -6 },
  { id: "America/Monterrey", label: "MTY", city: "Monterrey", country: "Mexico", offset: -6 },
  { id: "America/Cancun", label: "CUN", city: "Cancun", country: "Mexico", offset: -5 },
  { id: "America/Guadalajara", label: "GDL", city: "Guadalajara", country: "Mexico", offset: -6 },
  { id: "America/Tijuana", label: "TIJ", city: "Tijuana", country: "Mexico", offset: -8 },
  { id: "America/Merida", label: "MID", city: "Merida", country: "Mexico", offset: -6 },
  { id: "America/Hermosillo", label: "HMO", city: "Hermosillo", country: "Mexico", offset: -7 },
  { id: "America/Chihuahua", label: "CUU", city: "Chihuahua", country: "Mexico", offset: -6 },

  // North America - Canada
  { id: "America/Toronto", label: "YYZ", city: "Toronto", country: "Canada", offset: -5 },
  { id: "America/Vancouver", label: "YVR", city: "Vancouver", country: "Canada", offset: -8 },
  { id: "America/Montreal", label: "YUL", city: "Montreal", country: "Canada", offset: -5 },
  { id: "America/Calgary", label: "YYC", city: "Calgary", country: "Canada", offset: -7 },
  { id: "America/Edmonton", label: "YEG", city: "Edmonton", country: "Canada", offset: -7 },

  // Central America & Caribbean
  { id: "America/Panama", label: "PTY", city: "Panama City", country: "Panama", offset: -5 },
  {
    id: "America/Guatemala",
    label: "GUA",
    city: "Guatemala City",
    country: "Guatemala",
    offset: -6,
  },
  { id: "America/Costa_Rica", label: "SJO", city: "San Jose", country: "Costa Rica", offset: -6 },
  { id: "America/Havana", label: "HAV", city: "Havana", country: "Cuba", offset: -5 },
  {
    id: "America/Santo_Domingo",
    label: "SDQ",
    city: "Santo Domingo",
    country: "Dom. Rep.",
    offset: -4,
  },
  { id: "America/Puerto_Rico", label: "SJU", city: "San Juan", country: "Puerto Rico", offset: -4 },
  { id: "America/Jamaica", label: "KIN", city: "Kingston", country: "Jamaica", offset: -5 },

  // South America
  { id: "America/Sao_Paulo", label: "GRU", city: "São Paulo", country: "Brazil", offset: -3 },
  {
    id: "America/Rio_de_Janeiro",
    label: "GIG",
    city: "Rio de Janeiro",
    country: "Brazil",
    offset: -3,
  },
  {
    id: "America/Buenos_Aires",
    label: "EZE",
    city: "Buenos Aires",
    country: "Argentina",
    offset: -3,
  },
  { id: "America/Santiago", label: "SCL", city: "Santiago", country: "Chile", offset: -4 },
  { id: "America/Lima", label: "LIM", city: "Lima", country: "Peru", offset: -5 },
  { id: "America/Bogota", label: "BOG", city: "Bogota", country: "Colombia", offset: -5 },
  { id: "America/Caracas", label: "CCS", city: "Caracas", country: "Venezuela", offset: -4 },
  { id: "America/Montevideo", label: "MVD", city: "Montevideo", country: "Uruguay", offset: -3 },

  // Europe - Western
  { id: "Europe/London", label: "LHR", city: "London", country: "UK", offset: 0 },
  { id: "Europe/Paris", label: "CDG", city: "Paris", country: "France", offset: 1 },
  { id: "Europe/Madrid", label: "MAD", city: "Madrid", country: "Spain", offset: 1 },
  { id: "Europe/Barcelona", label: "BCN", city: "Barcelona", country: "Spain", offset: 1 },
  { id: "Europe/Lisbon", label: "LIS", city: "Lisbon", country: "Portugal", offset: 0 },
  { id: "Europe/Amsterdam", label: "AMS", city: "Amsterdam", country: "Netherlands", offset: 1 },
  { id: "Europe/Brussels", label: "BRU", city: "Brussels", country: "Belgium", offset: 1 },
  { id: "Europe/Dublin", label: "DUB", city: "Dublin", country: "Ireland", offset: 0 },

  // Europe - Central
  { id: "Europe/Berlin", label: "BER", city: "Berlin", country: "Germany", offset: 1 },
  { id: "Europe/Frankfurt", label: "FRA", city: "Frankfurt", country: "Germany", offset: 1 },
  { id: "Europe/Munich", label: "MUC", city: "Munich", country: "Germany", offset: 1 },
  { id: "Europe/Zurich", label: "ZRH", city: "Zurich", country: "Switzerland", offset: 1 },
  { id: "Europe/Geneva", label: "GVA", city: "Geneva", country: "Switzerland", offset: 1 },
  { id: "Europe/Vienna", label: "VIE", city: "Vienna", country: "Austria", offset: 1 },
  { id: "Europe/Rome", label: "FCO", city: "Rome", country: "Italy", offset: 1 },
  { id: "Europe/Milan", label: "MXP", city: "Milan", country: "Italy", offset: 1 },
  { id: "Europe/Prague", label: "PRG", city: "Prague", country: "Czech Rep.", offset: 1 },
  { id: "Europe/Warsaw", label: "WAW", city: "Warsaw", country: "Poland", offset: 1 },
  { id: "Europe/Copenhagen", label: "CPH", city: "Copenhagen", country: "Denmark", offset: 1 },
  { id: "Europe/Stockholm", label: "ARN", city: "Stockholm", country: "Sweden", offset: 1 },
  { id: "Europe/Oslo", label: "OSL", city: "Oslo", country: "Norway", offset: 1 },
  { id: "Europe/Helsinki", label: "HEL", city: "Helsinki", country: "Finland", offset: 2 },

  // Europe - Eastern
  { id: "Europe/Moscow", label: "SVO", city: "Moscow", country: "Russia", offset: 3 },
  { id: "Europe/Istanbul", label: "IST", city: "Istanbul", country: "Turkey", offset: 3 },
  { id: "Europe/Athens", label: "ATH", city: "Athens", country: "Greece", offset: 2 },
  { id: "Europe/Bucharest", label: "OTP", city: "Bucharest", country: "Romania", offset: 2 },
  { id: "Europe/Kiev", label: "KBP", city: "Kyiv", country: "Ukraine", offset: 2 },

  // Middle East
  { id: "Asia/Dubai", label: "DXB", city: "Dubai", country: "UAE", offset: 4 },
  { id: "Asia/Abu_Dhabi", label: "AUH", city: "Abu Dhabi", country: "UAE", offset: 4 },
  { id: "Asia/Riyadh", label: "RUH", city: "Riyadh", country: "Saudi Arabia", offset: 3 },
  { id: "Asia/Doha", label: "DOH", city: "Doha", country: "Qatar", offset: 3 },
  { id: "Asia/Kuwait", label: "KWI", city: "Kuwait City", country: "Kuwait", offset: 3 },
  { id: "Asia/Bahrain", label: "BAH", city: "Manama", country: "Bahrain", offset: 3 },
  { id: "Asia/Jerusalem", label: "TLV", city: "Tel Aviv", country: "Israel", offset: 2 },
  { id: "Asia/Beirut", label: "BEY", city: "Beirut", country: "Lebanon", offset: 2 },
  { id: "Asia/Tehran", label: "IKA", city: "Tehran", country: "Iran", offset: 3.5 },

  // Asia - South
  { id: "Asia/Kolkata", label: "DEL", city: "Delhi", country: "India", offset: 5.5 },
  { id: "Asia/Mumbai", label: "BOM", city: "Mumbai", country: "India", offset: 5.5 },
  { id: "Asia/Bangalore", label: "BLR", city: "Bangalore", country: "India", offset: 5.5 },
  { id: "Asia/Karachi", label: "KHI", city: "Karachi", country: "Pakistan", offset: 5 },
  { id: "Asia/Dhaka", label: "DAC", city: "Dhaka", country: "Bangladesh", offset: 6 },
  { id: "Asia/Colombo", label: "CMB", city: "Colombo", country: "Sri Lanka", offset: 5.5 },

  // Asia - Southeast
  { id: "Asia/Singapore", label: "SIN", city: "Singapore", country: "Singapore", offset: 8 },
  { id: "Asia/Bangkok", label: "BKK", city: "Bangkok", country: "Thailand", offset: 7 },
  { id: "Asia/Kuala_Lumpur", label: "KUL", city: "Kuala Lumpur", country: "Malaysia", offset: 8 },
  { id: "Asia/Jakarta", label: "CGK", city: "Jakarta", country: "Indonesia", offset: 7 },
  { id: "Asia/Bali", label: "DPS", city: "Bali", country: "Indonesia", offset: 8 },
  { id: "Asia/Manila", label: "MNL", city: "Manila", country: "Philippines", offset: 8 },
  { id: "Asia/Ho_Chi_Minh", label: "SGN", city: "Ho Chi Minh", country: "Vietnam", offset: 7 },
  { id: "Asia/Hanoi", label: "HAN", city: "Hanoi", country: "Vietnam", offset: 7 },

  // Asia - East
  { id: "Asia/Tokyo", label: "TYO", city: "Tokyo", country: "Japan", offset: 9 },
  { id: "Asia/Osaka", label: "KIX", city: "Osaka", country: "Japan", offset: 9 },
  { id: "Asia/Seoul", label: "ICN", city: "Seoul", country: "South Korea", offset: 9 },
  { id: "Asia/Hong_Kong", label: "HKG", city: "Hong Kong", country: "China", offset: 8 },
  { id: "Asia/Shanghai", label: "PVG", city: "Shanghai", country: "China", offset: 8 },
  { id: "Asia/Beijing", label: "PEK", city: "Beijing", country: "China", offset: 8 },
  { id: "Asia/Taipei", label: "TPE", city: "Taipei", country: "Taiwan", offset: 8 },

  // Oceania
  { id: "Australia/Sydney", label: "SYD", city: "Sydney", country: "Australia", offset: 11 },
  { id: "Australia/Melbourne", label: "MEL", city: "Melbourne", country: "Australia", offset: 11 },
  { id: "Australia/Brisbane", label: "BNE", city: "Brisbane", country: "Australia", offset: 10 },
  { id: "Australia/Perth", label: "PER", city: "Perth", country: "Australia", offset: 8 },
  { id: "Pacific/Auckland", label: "AKL", city: "Auckland", country: "New Zealand", offset: 13 },
  { id: "Pacific/Fiji", label: "SUV", city: "Suva", country: "Fiji", offset: 12 },

  // Africa
  {
    id: "Africa/Johannesburg",
    label: "JNB",
    city: "Johannesburg",
    country: "South Africa",
    offset: 2,
  },
  { id: "Africa/Cape_Town", label: "CPT", city: "Cape Town", country: "South Africa", offset: 2 },
  { id: "Africa/Cairo", label: "CAI", city: "Cairo", country: "Egypt", offset: 2 },
  { id: "Africa/Lagos", label: "LOS", city: "Lagos", country: "Nigeria", offset: 1 },
  { id: "Africa/Nairobi", label: "NBO", city: "Nairobi", country: "Kenya", offset: 3 },
  { id: "Africa/Casablanca", label: "CMN", city: "Casablanca", country: "Morocco", offset: 1 },

  // UTC
  { id: "UTC", label: "UTC", city: "Coordinated Universal Time", country: "UTC", offset: 0 },
];

// Group timezones by region for organized display
export const TIMEZONE_REGIONS = {
  "North America - USA": TIMEZONE_DATABASE.filter((tz) => tz.country === "USA"),
  "North America - Mexico": TIMEZONE_DATABASE.filter((tz) => tz.country === "Mexico"),
  "North America - Canada": TIMEZONE_DATABASE.filter((tz) => tz.country === "Canada"),
  "Central America & Caribbean": TIMEZONE_DATABASE.filter((tz) =>
    ["Panama", "Guatemala", "Costa Rica", "Cuba", "Dom. Rep.", "Puerto Rico", "Jamaica"].includes(
      tz.country
    )
  ),
  "South America": TIMEZONE_DATABASE.filter((tz) =>
    ["Brazil", "Argentina", "Chile", "Peru", "Colombia", "Venezuela", "Uruguay"].includes(
      tz.country
    )
  ),
  "Europe - Western": TIMEZONE_DATABASE.filter((tz) =>
    ["UK", "France", "Spain", "Portugal", "Netherlands", "Belgium", "Ireland"].includes(tz.country)
  ),
  "Europe - Central": TIMEZONE_DATABASE.filter((tz) =>
    [
      "Germany",
      "Switzerland",
      "Austria",
      "Italy",
      "Czech Rep.",
      "Poland",
      "Denmark",
      "Sweden",
      "Norway",
      "Finland",
    ].includes(tz.country)
  ),
  "Europe - Eastern": TIMEZONE_DATABASE.filter((tz) =>
    ["Russia", "Turkey", "Greece", "Romania", "Ukraine"].includes(tz.country)
  ),
  "Middle East": TIMEZONE_DATABASE.filter((tz) =>
    ["UAE", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Israel", "Lebanon", "Iran"].includes(
      tz.country
    )
  ),
  "Asia - South": TIMEZONE_DATABASE.filter((tz) =>
    ["India", "Pakistan", "Bangladesh", "Sri Lanka"].includes(tz.country)
  ),
  "Asia - Southeast": TIMEZONE_DATABASE.filter((tz) =>
    ["Singapore", "Thailand", "Malaysia", "Indonesia", "Philippines", "Vietnam"].includes(
      tz.country
    )
  ),
  "Asia - East": TIMEZONE_DATABASE.filter((tz) =>
    ["Japan", "South Korea", "China", "Taiwan"].includes(tz.country)
  ),
  Oceania: TIMEZONE_DATABASE.filter((tz) =>
    ["Australia", "New Zealand", "Fiji"].includes(tz.country)
  ),
  Africa: TIMEZONE_DATABASE.filter((tz) =>
    ["South Africa", "Egypt", "Nigeria", "Kenya", "Morocco"].includes(tz.country)
  ),
  UTC: TIMEZONE_DATABASE.filter((tz) => tz.country === "UTC"),
};

// Major/representative city per country — used when seeding default world
// clocks for a new user: UTC + user's base tz + a prominent city in the same
// country (so the board has two local-ish references plus UTC).
const MAJOR_CITY_BY_COUNTRY = {
  USA: "America/New_York",
  Mexico: "America/Mexico_City",
  Canada: "America/Toronto",
  Panama: "America/Panama",
  Guatemala: "America/Guatemala",
  "Costa Rica": "America/Costa_Rica",
  Cuba: "America/Havana",
  "Dom. Rep.": "America/Santo_Domingo",
  "Puerto Rico": "America/Puerto_Rico",
  Jamaica: "America/Jamaica",
  Brazil: "America/Sao_Paulo",
  Argentina: "America/Buenos_Aires",
  Chile: "America/Santiago",
  Peru: "America/Lima",
  Colombia: "America/Bogota",
  Venezuela: "America/Caracas",
  Uruguay: "America/Montevideo",
  UK: "Europe/London",
  France: "Europe/Paris",
  Spain: "Europe/Madrid",
  Portugal: "Europe/Lisbon",
  Netherlands: "Europe/Amsterdam",
  Belgium: "Europe/Brussels",
  Ireland: "Europe/Dublin",
  Germany: "Europe/Berlin",
  Switzerland: "Europe/Zurich",
  Austria: "Europe/Vienna",
  Italy: "Europe/Rome",
  "Czech Rep.": "Europe/Prague",
  Poland: "Europe/Warsaw",
  Denmark: "Europe/Copenhagen",
  Sweden: "Europe/Stockholm",
  Norway: "Europe/Oslo",
  Finland: "Europe/Helsinki",
  Russia: "Europe/Moscow",
  Turkey: "Europe/Istanbul",
  Greece: "Europe/Athens",
  Romania: "Europe/Bucharest",
  Ukraine: "Europe/Kiev",
  UAE: "Asia/Dubai",
  "Saudi Arabia": "Asia/Riyadh",
  Qatar: "Asia/Qatar",
  Kuwait: "Asia/Kuwait",
  Bahrain: "Asia/Bahrain",
  Israel: "Asia/Jerusalem",
  Lebanon: "Asia/Beirut",
  Iran: "Asia/Tehran",
  India: "Asia/Kolkata",
  Pakistan: "Asia/Karachi",
  Bangladesh: "Asia/Dhaka",
  "Sri Lanka": "Asia/Colombo",
  Singapore: "Asia/Singapore",
  Thailand: "Asia/Bangkok",
  Malaysia: "Asia/Kuala_Lumpur",
  Indonesia: "Asia/Jakarta",
  Philippines: "Asia/Manila",
  Vietnam: "Asia/Ho_Chi_Minh",
  Japan: "Asia/Tokyo",
  "South Korea": "Asia/Seoul",
  China: "Asia/Shanghai",
  Taiwan: "Asia/Taipei",
  Australia: "Australia/Sydney",
  "New Zealand": "Pacific/Auckland",
  Fiji: "Pacific/Fiji",
  "South Africa": "Africa/Johannesburg",
  Egypt: "Africa/Cairo",
  Nigeria: "Africa/Lagos",
  Kenya: "Africa/Nairobi",
  Morocco: "Africa/Casablanca",
};

const FALLBACK_CLOCKS = [
  { id: "UTC", label: "UTC" },
  { id: "America/New_York", label: "NYC" },
  { id: "America/Mexico_City", label: "MEX" },
];

/**
 * Build the default 3-clock list for a user given their ops timezone (tz id
 * like "America/Monterrey"). Slot order is always:
 *   1) UTC
 *   2) User's base timezone
 *   3) Major city in the same country, different from slot 2
 *
 * If base tz is unknown/UTC or the country has no mapping, falls back to the
 * legacy UTC/NYC/MEX board so the TopHeader never renders empty.
 */
export function buildDefaultClocks(opsTimezone) {
  if (!opsTimezone || opsTimezone === "UTC") return FALLBACK_CLOCKS;
  const base = TIMEZONE_DATABASE.find((tz) => tz.id === opsTimezone);
  if (!base) return FALLBACK_CLOCKS;

  const result = [
    { id: "UTC", label: "UTC" },
    { id: base.id, label: base.label },
  ];

  const majorId = MAJOR_CITY_BY_COUNTRY[base.country];
  const major =
    majorId && majorId !== base.id ? TIMEZONE_DATABASE.find((tz) => tz.id === majorId) : null;
  if (major) {
    result.push({ id: major.id, label: major.label });
  } else {
    // Country has no mapping (or base === major). Pick any other tz in the
    // same country; last resort NYC so we always return 3.
    const alt = TIMEZONE_DATABASE.find((tz) => tz.country === base.country && tz.id !== base.id);
    result.push(alt ? { id: alt.id, label: alt.label } : { id: "America/New_York", label: "NYC" });
  }
  return result;
}

export default TIMEZONE_DATABASE;
